export default "__VITE_ASSET__739b0a91__"